<template>
  <div :class="['drive-container',draging ? 'draging': '']" @dragover="dragover" @dragenter.prevent="() => {}" @dragover.prevent="() => {}" @drop.prevent="test">
    <aside-menu/>
    <div class="router-box">
      <router-view></router-view>
    </div>
    <avatar v-if="rightAvatar"/>
    <affix/>
    <context-menu v-if="contextMenuVisible" />
    <iframe v-if="frameUrl" class="downloadframe" :src="frameUrl"></iframe>
    <my-dialog />
    <uploader @dragle="dragend" v-if="isCef"/>
    <div class="drop-wraper">
        <div id="dropzone" @dragleave="dragend" @drop="dragend">
            <p class="uploader-tip"><span class="components-icons-box"><i class="components-icons components-icons-upload-s"><span class="path1"></span></i></span>{{this.$t('Upfile')}}</p>
        </div>
    </div>
  </div>
</template>
<script>
import {mapMutations, mapState, mapActions, mapGetters} from 'vuex'
import AsideMenu from '@/components/AsideMenu.vue'
import Avatar from '@/components/Avatar.vue'
import ContextMenu from '@/components/ContextMenu'
import Affix from '@/components/uploader/Affix'

import MyDialog from '@/components/dialog'
import Uploader from '@/components/uploader'

export default {
  data(){
    return {
      timer: null,
      initUpload: false,
      draging: false
    }
  },
  components:{
    AsideMenu,
    Avatar,
    ContextMenu,
    Affix,
    MyDialog,
    Uploader
  },
  created(){
    this.checkLogin({
      cached: true,
      csrfmiddlewaretoken: '917f3d15e03ed01ca2da780b4e4f6ed9'
    })
    if (localStorage.getItem('drive_sort')) {
      let sort = localStorage.getItem('drive_sort')
      let sortData
      try {
        sortData = JSON.parse(sort) 
      } catch (error) {
        sortData = {
            id: 2,
            order: 'DESC',
            orderby: 'mtime'
          }
      }

      this.$store.commit('UPDATE_SORT',sortData)
    }
    
    this.timer = setInterval(() => {
      this.UPDATE_TIME(60)
    }, 60000);
  },
  mounted(){
    window.addEventListener('message',(e) => {
      let {eventName,...paload} = typeof e.data == 'string' ? JSON.parse(e.data) : e.data
      if (eventName == "refreshFileList") {
          this.$store.dispatch('index/renameSuccess',paload)
      }
    })
    if(window.cefQuery){
      window.dragCallback = this.dragCallback
      wpsApi({method: 'common.event.addEventListener',params:{eventName: 'ondragenter',callbackName:'dragCallback'}},function(res){console.log(res)})
    }
  },
  computed:{
    ...mapState([
      'frameUrl',
      'contextMenuVisible',
      'group',
      'parentid',
      'route'
    ]),
    ...mapGetters('index',[
      'shouldFlush'
    ]),
    isCef(){
      return !window.cefQuery
    },
    rightAvatar(){
      return !window.cefQuery
    }
  },
  methods:{
    ...mapMutations([
      'UPDATE_TIME'
    ]),
    ...mapActions('user',[
		  'checkLogin'
    ]),
    ...mapActions('events',[
      'flush'
    ]),
    dragover(){
      this.draging = true
    },
    dragend(){
      this.draging = false
    },
    dragCallback(e){
      let {tid,fid} = this.$route.params
      let groupid = tid || this.group
      let parentid = fid || this.parentid
      let files = JSON.parse(e.replace(/\\/g,'/')).files
      wpsApi({method: 'jsUploadDragFiles',params:{
          groupid,
          parentid,
          files
      }},function(res){
          console.log(res)
      })
    },
    test(e){
      e.preventDefault()
      
    }
  },
  beforeDestroy(){
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>

<style>
.drive-container{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    min-width: 960px;
    bottom: 0;
    display: flex;
}
.router-box{
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.router-container{
  display: flex;
  flex: 1;
  height: 100%;
  min-height: 0;
}
.downloadframe{
  display: none;
}
#dropzone{
    position: fixed;
    z-index: 2019;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: none;
}
.draging #dropzone{
    display: block;
    background: rgba(255,255,255,.5);
}
.uploader-tip{
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    padding: 10px 12px;
    color: #2e68f8;
    margin: 20px auto;
    font-size: 14px;
    z-index: 5000;
    background: #fff;
    box-shadow: 0 2px 9px 0 rgba(46,104,248,.2);
    border-radius: 2px;
}
.uploader-tip span{
    margin-right: 6px;
}
</style>


// WEBPACK FOOTER //
// src/layouts/default.vue